import { createContext, useState } from 'react';

export const RANGE_TABS = {
  today: 0,
  last7Days: 1,
  last30days: 2,
  week: 3,
  month: 4,
  year: 5,
};

export const RangeTabsContext = createContext({});

const RangeTabsContextProvider = ({ children }) => {
  const [rangeActiveIndex, setRangeActiveIndex] = useState(
    RANGE_TABS.last7Days
  );

  return (
    <RangeTabsContext.Provider
      value={{
        rangeActiveIndex,
        setRangeActiveIndex,
      }}
    >
      {children}
    </RangeTabsContext.Provider>
  );
};

export default RangeTabsContextProvider;
